import { render } from "./ExamRecord.vue?vue&type=template&id=9e99ff12&scoped=true"
import script from "./ExamRecord.vue?vue&type=script&lang=js"
export * from "./ExamRecord.vue?vue&type=script&lang=js"

import "./ExamRecord.vue?vue&type=style&index=0&id=9e99ff12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e99ff12"]])

export default __exports__